module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.hasPermission('usuario.read')) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Atendimentos Marcados")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.total_marcacao))])])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('usuario.read')) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Atendimentos Regulados")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.total_regulacao))])])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('usuario.read')) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Atendimentos Negativados")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.total_negativado))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("COMUNICADOS IMPORTANTES")]), _vm._v(" "), _vm._l((_vm.comunicados.data), function(comunicado, index) {
    return [(comunicado[((_vm.$store.state.user.nivel) + "_visualiza")]) ? _c('div', {
      key: index,
      staticClass: "box box-success"
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h3', {
      staticClass: "box-title"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("dataFormatada")(comunicado.data_inicial)) + " - " + _vm._s(comunicado.titulo))])])]), _vm._v(" "), _c('div', {
      staticClass: "box-body",
      domProps: {
        "innerHTML": _vm._s(comunicado.descricao)
      }
    })]) : _vm._e()]
  }), _vm._v(" "), (_vm.comunicados.data.length == 0) ? _c('div', [_vm._v("\n\t\t\tNenhum comunicado vigente.\n\t\t")]) : _vm._e()], 2), _vm._v(" "), (_vm.visualizaArquivo) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("DOCUMENTOS COMPARTILHADOS")]), _vm._v(" "), _vm._m(3)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-warning"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('p', [_c('strong', [_vm._v("10/12/2020")]), _vm._v("  - "), _c('a', {
    attrs: {
      "href": "/static/docs/profissionais-cemae.pdf",
      "download": ""
    }
  }, [_vm._v("Relação de profissionais do CEMAE no mês de Novembro 2020 (3ª fase de reabertura)")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("04/10/2019")]), _vm._v("  - "), _c('a', {
    attrs: {
      "href": "/static/docs/circular6.pdf",
      "download": ""
    }
  }, [_vm._v("OFÍCIO CIRCULAR Nº. 006/2019-GAB/SMS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1663747f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = 804
// module chunks = 0